import React, { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import { Link, useParams, useHistory } from "react-router-dom";
import { size } from "lodash";
import { useProduct } from "../../hooks";
import { getProductsCart } from "../../api/cart";
import { ListProductCart } from "../../components/Client";
import "./Cart.scss";

export function Cart() {
  const [products, setProducts] = useState(null);
  const [reloadCart, setReloadCart] = useState(false);
  const { getProductById } = useProduct();
  const { tableNumber } = useParams();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const productsCart = getProductsCart();

      const productsArray = [];
      for await (const cartItem of productsCart) {
        const response = await getProductById(cartItem.id);
        productsArray.push({
          ...response,
          quantity: cartItem.quantity,
          note: cartItem.note,
          optionChoice: cartItem.optionChoice,
          extras: cartItem.extras,
          unitPrice: cartItem.unitPrice,
          offerId: cartItem.offerId,
          offerTitle: cartItem.offerTitle,
        });
      }
      setProducts(productsArray);
    })();
  }, [reloadCart]);

  const onReloadCart = () => setReloadCart((prev) => !prev);
  const goToMenu = () => history.push(`/client/${tableNumber}`);

  return (
    <div>
      <Button
        icon
        labelPosition="left"
        className="cart__back"
        onClick={goToMenu}
      >
        <Icon name="arrow left" />
        Regresar al Menu
      </Button>

      <h1>Carrito</h1>
      {!products ? (
        <p>Cargando...</p>
      ) : size(products) === 0 ? (
        <div style={{ textAlign: "center" }}>
          <p>Tu carrito esta vacio</p>
          <Link to={`/client/${tableNumber}/orders`}>
            <Button primary>Ver pedidos</Button>
          </Link>
        </div>
      ) : (
        <ListProductCart products={products} onReloadCart={onReloadCart} />
      )}
    </div>
  );
}
